<template>
  <v-form v-model="valid" ref="mainForm">
    <data-iterator
      :list="sas.sasEquivalenceDiplome"
      add-new-text="Ajouter un diplôme"
      :live="{ endpoint: 'sas-diplomes', sasId: sas.id }"
      :icon="$getIcon('school')"
      :valids="valids"
      ref="dataIterator"
    >
      <template v-slot:show-mode="{ item }">
        <p class="mb-0">
          {{ item.titreDuDiplome }}
        </p>
        <p class="mb-0">
          {{ item.universite }}
        </p>
      </template>
      <template v-slot:edit-mode="{ item }">
        <TextFieldLive code="diplome_titre" v-model="item.titreDuDiplome" :live="liveSasDiplomes(6302, item)" />
        <CatalogueLive code="diplome_pays" v-model="item.pays" :live="liveSasDiplomes(6305, item)" />
        <DatePickerLive
          code="diplome_date"
          v-model="item.dateDObtention"
          :live="liveSasDiplomes(6312, item)"
          :maxValue="convertDateToString(new Date())"
        />
        <CatalogueLive code="diplome_niveau" v-model="item.niveauDEtude" :live="liveSasDiplomes(6310, item)" />
        <CatalogueLive
          code="diplome_cycle"
          v-model="item.cycleDEtudes"
          :live="liveSasDiplomes(6313, item)"
          :opq-if="estUniversitaire(item.niveauDEtude)"
        />
        <NumberLive code="diplome_duree" v-model="item.dureeEnAnnee" :live="liveSasDiplomes(6311, item)" />
        <TextFieldLive code="diplome_etablissement" v-model="item.universite" :live="liveSasDiplomes(6304, item)" />
        <CatalogueLive code="diplome_description_ouinon" v-model="item.descriptionDesCoursDisponible" :live="liveSasDiplomes(6303, item)" />
        <FileInput
          code="diplome_description_fichier"
          :file="item.fichierDescriptionCours"
          :live="liveSasDiplomes(6309, item)"
          :opq-if="estOui(item.descriptionDesCoursDisponible)"
          @file-deleted="item.fichierDescriptionCours = null"
        />
        <FileInput code="diplome_preuve" :file="item.copieDuDiplome" :live="liveSasDiplomes(6307, item)" />
        <FileInput code="diplome_notes" :file="item.releveDeNotes" :live="liveSasDiplomes(6308, item)" />
      </template>
    </data-iterator>
  </v-form>
</template>

<script>
import DatesHelpers from "@/components/ui/mixins/DatesHelpers"
import CataloguesHelpers from "@/components/ui/mixins/CataloguesHelpers"
import StepFormWithValidation from "@/mixins/StepFormWithValidation"

export default {
  mixins: [CataloguesHelpers, StepFormWithValidation, DatesHelpers],
  props: {
    sas: { type: Object }
  },
  methods: {
    liveSasDiplomes(cle, item) {
      return { endpoint: "sas-diplomes", cle: cle, fileId: item.id }
    },
    estUniversitaire(niveauEtude) {
      return this.getCatalogueCodeById("6310", niveauEtude) == "UNI"
    },
    disabledAfterToday(date) {
      const today = new Date()
      today.setHours(0, 0, 0, 0)
      return date > today
    }
  }
}
</script>

<style></style>
